import getNameTransportType from 'utils/getNameTransportType';
import { IAdvertItem } from 'interfaces/IAdvertItem';
import { AdvertItemType } from 'interfaces/IAdvert';
import stringifyLongNumber from 'utils/stringifyLongNumber';

type NotRequiredNumber = number | undefined;
type NotRequiredString = string | undefined;

interface IOptions {
  type: AdvertItemType;
  isFirstItem: boolean;
}

class AdvertItemDataModel {
  protected item: IAdvertItem;
  public type: AdvertItemType;
  public isFirstItem: boolean;

  constructor(item: IAdvertItem, options: IOptions) {
    this.item = item;
    this.type = options.type;
    this.isFirstItem = options.isFirstItem;
  }

  get isTractor(): boolean {
    return this.type === 'tractor';
  }

  get isTrailer(): boolean {
    return this.type === 'trailer';
  }

  get isSemitrailer(): boolean {
    return this.type === 'semitrailer';
  }

  get seatsCount(): NotRequiredNumber {
    return this.item.seats_count;
  }

  get busType(): NotRequiredString {
    return this.item.bus_type;
  }

  get workingHours(): NotRequiredNumber {
    return this.item.working_hours;
  }

  get excavatorType(): NotRequiredString {
    return this.item.excavator_type;
  }

  get loaderType(): NotRequiredString {
    return this.item.loader_type;
  }

  get tractorType(): NotRequiredString {
    return this.item.tractor_type;
  }

  get nameOfType(): string {
    return getNameTransportType(this.type, {
      special_type: this.item.special_type || 'Спецтехника',
    });
  }

  get brand(): string {
    return this.item.brand.name;
  }

  get model(): NotRequiredString {
    return this.item.model?.model;
  }

  get year(): NotRequiredNumber {
    return this.item.year;
  }

  get mileage(): NotRequiredNumber {
    return this.item.mileage;
  }

  get bodyType(): NotRequiredNumber {
    return this.item.body_type;
  }

  get capacity(): NotRequiredNumber {
    return this.item.capacity;
  }

  get volume(): NotRequiredNumber {
    return this.item.volume;
  }

  get engineVolume(): NotRequiredNumber {
    return this.item.engine_volume;
  }

  get engineType(): NotRequiredNumber {
    return this.item.engine_type;
  }

  get enginePower(): NotRequiredNumber {
    return this.item.engine_power;
  }

  get gearboxType(): NotRequiredNumber {
    return this.item.gearbox_type;
  }

  get formattedMileage(): string {
    if (this.mileage === undefined) return '';
    const [num, text] = stringifyLongNumber(this.mileage, 'км');
    return `${num}\u00A0${text}`;
  }

  get formattedWorkingHours(): string {
    if (this.workingHours === undefined) return '';
    const [num, text] = stringifyLongNumber(this.workingHours, 'м.ч.');
    return `${num}\u00A0${text}`;
  }
}

export default AdvertItemDataModel;
